import { Injectable } from '@angular/core';
import { BaseUploadHandler } from './base-upload-handler';
import { DirectUploadHandler } from './direct-upload-handler';
import { ChunkedUploadHandler } from './chunked-upload-handler';
import { MTMCustomFile } from '../mtm-custom-file';

@Injectable({
  providedIn: 'root',
})
export class UploadHandlerFactory {
  private readonly handlers: BaseUploadHandler[];

  constructor(
    private readonly directUploadHandler: DirectUploadHandler,
    private readonly chunkedUploadHandler: ChunkedUploadHandler
  ) {
    this.handlers = [this.directUploadHandler, this.chunkedUploadHandler];
  }

  /**
   * Gets the appropriate upload handler for the given file based on its step
   * @param file - The file to get handler for
   * @returns The upload handler that can process the file
   */
  public getHandler(file: MTMCustomFile): BaseUploadHandler | null {
    return this.handlers.find((handler: BaseUploadHandler) => handler.canHandle(file)) || null;
  }

  /**
   * Gets handler by step name
   * @param step - The upload step name
   * @returns The upload handler for the step
   */
  public getHandlerByStep(step: string): BaseUploadHandler | null {
    switch (step) {
      case 'upload':
        return this.directUploadHandler;
      case 'chunkUpload':
        return this.chunkedUploadHandler;
      default:
        return null;
    }
  }
}
